export default __webpack_public_path__ + "static/SingleXL-411e23a2053eb1f1e4f20ef8900a72f4.svg";